<!-- eslint-env browser -->
<!-- eslint-disable vue/no-setup-props-destructure -->
<template>
  <DetailCard
    v-if="!isLoading"
    key="urun-satis-durumu"
    title="Ürün & Satış Durumu"
    cardClass="section-status"
    cardKey="product-status"
  >
    <div class="status-container">
      <ProductStatusCard
        :productStatus="productStatus"
        @refetchProductDetail="handleRefetchProductDetail"
        @scrollToSection="handleScrollToSection"
      />
    </div>
  </DetailCard>

  <ProductStatusSkeleton v-else />
</template>

<script setup>
/* eslint-env browser */
/* global defineProps, defineEmits */
import DetailCard from '../DetailCard';
import ProductStatusCard from './partial/ProductStatusCard';
import ProductStatusSkeleton from '@/components/Skeleton/ProductDetailSkeleton/ProductStatusSkeleton.vue'

const props = defineProps({
  productStatus: {
    type: Object,
    default: {}
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['refetchProductDetail', 'scrollToSection']);

const handleRefetchProductDetail = () => {
  emit('refetchProductDetail');
};

const handleScrollToSection = (sectionIndex) => {
  emit('scrollToSection', sectionIndex);
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.status-container {
  padding: 0;
}

@media (max-width: 960px) {
  .status-container {
    padding: 0 16px;
  }
}
</style>
